export const DEFAULT_LOCALE_STATE = {
	locale: 'en',
	messages: {},
};

export const NEW_DEFAULT_LOCALE_STATE = {
	locale: 'en-US',
	messages: undefined,
};
